// @flow

import React from 'react';
import { colors } from 'seedling/constants';

export type StopIconProps = {
  width: number,
  height: number,
  color: string,
};

const StopIcon = (props: StopIconProps) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5 4H4.5C4.22386 4 4 4.22386 4 4.5V15.5C4 15.7761 4.22386 16 4.5 16H15.5C15.7761 16 16 15.7761 16 15.5V4.5C16 4.22386 15.7761 4 15.5 4ZM4.5 2.5C3.39543 2.5 2.5 3.39543 2.5 4.5V15.5C2.5 16.6046 3.39543 17.5 4.5 17.5H15.5C16.6046 17.5 17.5 16.6046 17.5 15.5V4.5C17.5 3.39543 16.6046 2.5 15.5 2.5H4.5Z"
      fill={props.color}
    />
  </svg>
);

StopIcon.defaultProps = {
  color: colors.white,
  width: 20,
  height: 20,
};

export default StopIcon;
